import { render, staticRenderFns } from "./homeUp.vue?vue&type=template&id=2b14c85e"
import script from "./homeUp.vue?vue&type=script&lang=js"
export * from "./homeUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports